<script lang="ts" setup>
import { computed } from 'vue';
import { NotificationSurveyHistoryType } from '@/types';
import CardTemplate from './card-template.vue';

interface Props {
  notification: NotificationSurveyHistoryType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() => {
  return `/surveys/${props.notification.survey_history.survey_session_id}`;
});

const questionText = computed(() => {
  return `要約生成が完了しました。「${props.notification.survey_history.question}」`;
});
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :content-title="questionText"
  >
    要約生成：ディープリサーチが完了しました
  </CardTemplate>
</template>
